/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sent: NonNullable<unknown> }} Notify_Test_ResultInputs */

const en_notify_test_result = /** @type {(inputs: Notify_Test_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sent to ${i?.sent} devices.`)
};

const de_notify_test_result = /** @type {(inputs: Notify_Test_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An ${i?.sent} Geräte gesendet.`)
};

/**
* | output |
* | --- |
* | "Sent to {sent} devices." |
*
* @param {Notify_Test_ResultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_test_result = /** @type {((inputs: Notify_Test_ResultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_Test_ResultInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_test_result(inputs)
	return en_notify_test_result(inputs)
});